import React from 'react';

import { Formik, Field } from 'formik';
import * as Yup from 'yup';

import Button from 'CommonComponents/Button';

const PolicyCreateSchema = Yup.object().shape({
    total_cost: Yup.string().required('This value is required'),
    method: Yup.string().required('This value is required'),
    details: Yup.string().required('This value is required'),
});

export default function ProcurementPoliciesCreateForm(props) {
    return (
        <Formik
            initialValues={{
                total_cost: '',
                method: '',
                details: '',
            }}
            validationSchema={PolicyCreateSchema}
            onSubmit={(values, actions) => {
                axios
                    .post(props.storeUrl, values)
                    .then((response) => {
                        // IB-701: when hosted in the Setup slide-over an onSuccess callback drives a
                        // silent refetch; the standalone create page keeps its full-reload behaviour.
                        if (props.onSuccess) {
                            props.onSuccess(response);
                        } else {
                            window.location.replace(props.indexUrl);
                        }
                    })
                    .catch((e) => {
                        actions.setErrors(e.response.data.errors);
                    })
                    .finally(() => {
                        actions.setSubmitting(false);
                    });
            }}
        >
            {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue }) => (
                <div className={props.fullWidth ? '' : 'row'}>
                    <div className={props.fullWidth ? '' : 'col-sm-8 offset-sm-2 col-md-6 offset-md-3'}>
                        <div className={props.fullWidth ? '' : 'card bg-white border-0 rounded-15px py-2 shadow'}>
                            <div className={props.fullWidth ? '' : 'float-right'}>
                                <div className={props.fullWidth ? '' : 'card-body'}>
                                    <div className={'form-group'}>
                                        <label htmlFor="total_cost">
                                            {$t('Value')} <span className="text-danger">*</span>
                                        </label>
                                        <Field
                                            type="text"
                                            className={
                                                errors.total_cost && touched.total_cost ? 'form-control is-invalid border border-danger' : 'form-control'
                                            }
                                            name="total_cost"
                                            placeholder={$t('Example: $100,000 to $250,000')}
                                        />
                                        {errors.total_cost && touched.total_cost && <div className="text-danger">{errors.total_cost}</div>}
                                    </div>

                                    <div className={'form-group'}>
                                        <label htmlFor="method">
                                            {$t('Method')} <span className="text-danger">*</span>
                                        </label>
                                        <Field
                                            type="text"
                                            className={errors.method && touched.method ? 'form-control is-invalid border border-danger' : 'form-control'}
                                            name="method"
                                            placeholder={$t('Example: Select tender')}
                                        />
                                        {errors.method && touched.method && <div className="text-danger">{errors.method}</div>}
                                    </div>

                                    <div className={'form-group'}>
                                        <label htmlFor="details">
                                            {$t('Details')} <span className="text-danger">*</span>
                                        </label>
                                        <Field
                                            as={'textarea'}
                                            type="text"
                                            className={errors.details && touched.details ? 'form-control is-invalid border border-danger' : 'form-control'}
                                            name="details"
                                            placeholder={$t('Details')}
                                        />
                                        {errors.details && touched.details && <div className="text-danger">{errors.details}</div>}
                                    </div>

                                    <Button variant="primary" disabled={isSubmitting} onClick={handleSubmit}>
                                        {$t('Submit')}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Formik>
    );
}
